import { useContext } from 'react';
import { ComponentRendering, SitecoreContextReactContext } from '@sitecore-jss/sitecore-jss-react';
import { ContentHubHeroBannerSeriesDetailModel } from '../components/productHeroBannerSeriesDetail/models/productHeroBannerSeriesDetail.model';
import { TContentHubHeroBannerSeriesDetailProps } from '../components/productHeroBannerSeriesDetail/types/productHeroBannerSeriesDetail.types';
import { ProductHeroBannerModel } from '../components/productHeroBanner/models/productHeroBanner.model';
import { TContentHubHeroBannerProps } from '../components/productHeroBanner/types/productHeroBanner.types';
import { ProductSpecialOffersDetailHeroBannerModel } from '../components/ProductSpecialOffersDetailHeroBanner/models/ProductSpecialOffersDetailHeroBanner.model'
import { ProductSpecialOffersDetailHeroBannerProps } from '../components/ProductSpecialOffersDetailHeroBanner/types/ProductSpecialOffersDetailHeroBanner.types'
import { HeroBannerModel } from '../components/smallHero/models/heroBanner.model';
import useSitecoreContext from './useSitecoreContext';

const useHeroBanner = (): { isHeroBannerPresent: boolean; textColor: string } => {
  const sitecoreContextFactory = useContext(SitecoreContextReactContext);
  const excludedComponentNames = ['ProductSeoTags', 'ProductBreadcrumbBar', 'NavigationBarAnchorComponent', 'BreadcrumbBar'];
  const {sitecoreContext} = useSitecoreContext();
  const componentList = (sitecoreContext?.route?.placeholders['jss-main'] || []) as ComponentRendering[];
  const filteredComponentsList = componentList.filter((component) => !excludedComponentNames.includes(component.componentName));
  const heroBannerCompIndex = filteredComponentsList?.findIndex(
    (item) =>
      item.componentName === 'ProductHeroBannerSeriesDetail' ||
      item.componentName === 'ProductHeroBanner' ||
      item.componentName === 'SmallHero' ||
      item.componentName === 'HeroBanner'||
      item.componentName === 'FairHero' ||
      item.componentName === 'ProductSpecialOffersDetailHeroBanner'
  );
  const heroBannerData = filteredComponentsList?.[heroBannerCompIndex] as ComponentRendering;

  if (heroBannerData?.componentName === 'ProductHeroBannerSeriesDetail') {
    const sdHeroBannerModel = new ContentHubHeroBannerSeriesDetailModel(
      filteredComponentsList[heroBannerCompIndex] as any
      // TContentHubHeroBannerSeriesDetailProps -- original type to be referred later
    );

    const isHeroBannerPresent = !!(
      sdHeroBannerModel?.desktopImage?.url ||
      sdHeroBannerModel?.desktopSDImage?.url ||
      sdHeroBannerModel?.tabletImage?.url ||
      sdHeroBannerModel?.tabletLandscapeImage?.url ||
      sdHeroBannerModel?.mobileImage?.url
    );

    return {
      isHeroBannerPresent,
      textColor: sdHeroBannerModel?.textColor,
    };
  }

  if (heroBannerData?.componentName === 'ProductHeroBanner') {
    const pHeroBannerModel = new ProductHeroBannerModel(filteredComponentsList[heroBannerCompIndex] as TContentHubHeroBannerProps);

    const isHeroBannerPresent = !!(
      pHeroBannerModel?.desktopImage?.url ||
      pHeroBannerModel?.desktopSDImage?.url ||
      pHeroBannerModel?.tabletImage?.url ||
      pHeroBannerModel?.tabletLandscapeImage?.url ||
      pHeroBannerModel?.mobileImage?.url
    );

    return { isHeroBannerPresent, textColor: pHeroBannerModel.textColor };
  }

  if (heroBannerData?.componentName === 'SmallHero') {
    const smallHeroBannerModel = new HeroBannerModel(filteredComponentsList[heroBannerCompIndex] as any);

    const isHeroBannerPresent =
      !!(smallHeroBannerModel?.image?.value?.src || smallHeroBannerModel?.mobileImage?.value?.src) && heroBannerCompIndex === 0;

    return { isHeroBannerPresent, textColor: smallHeroBannerModel.textColor };
  }

  if (heroBannerData?.componentName === 'HeroBanner') {
    return { isHeroBannerPresent: heroBannerCompIndex === 0, textColor: '' };
  }

  if (heroBannerData?.componentName === 'ProductSpecialOffersDetailHeroBanner') {
    const soHeroBannerModel = new ProductSpecialOffersDetailHeroBannerModel(
      filteredComponentsList[heroBannerCompIndex] as ProductSpecialOffersDetailHeroBannerProps,
      sitecoreContext
    );

    const isHeroBannerPresent = !!(soHeroBannerModel?.desktopImage?.url || soHeroBannerModel?.mobileImage?.url);

    return { isHeroBannerPresent, textColor: soHeroBannerModel?.textColor as string };
  }

  return { isHeroBannerPresent: heroBannerCompIndex > -1, textColor: '' };
};

export default useHeroBanner;
